import { render, staticRenderFns } from "./ConstructionProjectsTableView.vue?vue&type=template&id=5beb42a9&scoped=true&"
import script from "./ConstructionProjectsTableView.vue?vue&type=script&lang=js&"
export * from "./ConstructionProjectsTableView.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionProjectsTableView.vue?vue&type=style&index=0&id=5beb42a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb42a9",
  null
  
)

/* custom blocks */
import block0 from "./ConstructionProjectsTableView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports